import React, { useEffect } from 'react';
import { COMMAND_PRIORITY_LOW } from 'lexical';
import { mergeRegister } from '@lexical/utils';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import {
  $createCodeHighLightNode,
  INSERT_CODE_HIGHLIGHT_COMMAND,
  $isCodeHighLightNode,
  toggleHighlightCode,
} from '../nodes/CodeHighLightNode';

const CodeHighlightPlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        INSERT_CODE_HIGHLIGHT_COMMAND,
        (isCode: boolean) => {
          editor.update(() => {
            toggleHighlightCode(isCode);
          });

          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    );
  }, [editor]);

  return null;
};

export default CodeHighlightPlugin;
export {
  INSERT_CODE_HIGHLIGHT_COMMAND,
  $createCodeHighLightNode,
  $isCodeHighLightNode,
  toggleHighlightCode,
};
